import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {IssueTypeDTO} from "../domain/dtos/issue-type.dto";
import {KeywordDTO} from "../domain/dtos/keyword.dto";
import {IssueType} from "../domain/entities/issue-type.entity";
import {TransformerInterface} from "./transformerInterface";

@injectable()
@transformer({
    source: IssueType,
    target: `dto`
})
export class IssueTypeToDtoTransformer implements TransformerInterface<Partial<IssueTypeDTO>, IssueType> {

    public transform(issueType: IssueType): Promise<Partial<KeywordDTO>> {
        const entries = new Map(Object.entries(issueType));

        const dto: Partial<IssueTypeDTO> = issueType.isNew()
            ? {
                uid: issueType.uid,
                description: issueType.description,
                cssClasses: issueType.cssClasses,
                include: issueType.include,
                shortcut: issueType.shortcut,
                showInHeader: issueType.showInHeader,
                createdAt: issueType.createdAt.toUTC().toSQL(),
                sorting: -1,
                color: issueType.color,
                textColor: issueType.textColor,
                parent: issueType.parentUid,
            }
            : Object.fromEntries(
                // The entity keeps the root as parentUid; the backend names the field parent.
                issueType.changedValues.map(propertyName => [
                    propertyName === `parentUid` ? `parent` : propertyName,
                    entries.get(`_${propertyName}`)!
                ])
            );

        dto.uid = issueType.uid;

        return Promise.resolve(dto);
    }
}
